import React, { useEffect, useState } from 'react';

export function usePathname() {
  const [pathname, setPathname] = useState(() => window.location.pathname);

  useEffect(() => {
    const sync = () => setPathname(window.location.pathname);
    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, []);

  return pathname.replace(/\/+$/, '') || '/';
}

const hashRoutes: Record<string, string> = {
  about: '/about',
  shows: '/shows',
  media: '/media',
  epk: '/epk',
  contact: '/contact',
  admin: '/admin',
};

export function navigate(href: string) {
  const url = new URL(href, window.location.origin);
  const hashRoute = hashRoutes[url.hash.replace('#', '')];
  if (hashRoute) {
    url.pathname = hashRoute;
    url.hash = '';
  }

  window.history.pushState({}, '', url.pathname + url.hash);
  window.dispatchEvent(new PopStateEvent('popstate'));

  if (url.hash) {
    requestAnimationFrame(() => {
      document.getElementById(url.hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
    });
    return;
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

type AppLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
};

export function AppLink({ href, onClick, ...props }: AppLinkProps) {
  return (
    <a
      href={href}
      {...props}
      onClick={(event) => {
        onClick?.(event);
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }
        event.preventDefault();
        navigate(href);
      }}
    />
  );
}
